export default __webpack_public_path__ + "img/ic-mitra.9dd8f173.svg";